var test = function (item) {
    let text = item.innerHTML;
    let firstSpaceIndex = text.indexOf(" ");
    if (firstSpaceIndex > 0) {
        var substrBefore = text.substring(0, firstSpaceIndex);
        var substrAfter = text.substring(firstSpaceIndex, text.length)
        var newText = '<span>' + substrBefore + '</span>' + substrAfter;
        item.innerHTML = newText;
    } else {
        item.innerHTML = '<span>' + text + '</span>';
    }

};

let item = document.querySelectorAll('.home_city__item__title');

if (item) {
    item.forEach(test);
}